// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NYDiU7jckq4e27EYrIL4 .uC1orRd2cdctwGCfTJc6{justify-content:space-between;gap:12px;display:flex}.NYDiU7jckq4e27EYrIL4 .V3GUihUDOREjdBNm363Y{height:44px;margin-top:40px;font-size:14px;font-weight:500}.NYDiU7jckq4e27EYrIL4 .aGl531TgLHEAxtjggQoP{width:100%}.NYDiU7jckq4e27EYrIL4 .HwBNFk6a380QSmWgcby5{padding:12px;font-size:14px;font-weight:400;line-height:20px}.NYDiU7jckq4e27EYrIL4 .HwBNFk6a380QSmWgcby5.TeDxIrWae0susvhiVtk0,.NYDiU7jckq4e27EYrIL4 .HwBNFk6a380QSmWgcby5.gCk9YEAH1hE_xuheJNrH{margin-bottom:4px}.NYDiU7jckq4e27EYrIL4 .HwBNFk6a380QSmWgcby5.HWeXUugxXYQg5Fj_W23U{cursor:auto}.NYDiU7jckq4e27EYrIL4 .sH9WBf3H9gMaF_Yar2pZ{margin-top:20px;margin-bottom:4px}.NYDiU7jckq4e27EYrIL4 .UDKgqMXiA8yyB4UAS87F{align-items:center;gap:4px;display:flex}.NYDiU7jckq4e27EYrIL4 .aG03BG9HgRIzpUELVSjB{text-align:center;color:var(--content-primary-tertiary);padding-top:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `NYDiU7jckq4e27EYrIL4`,
	"nameWrap": `uC1orRd2cdctwGCfTJc6`,
	"button": `V3GUihUDOREjdBNm363Y`,
	"fieldWrap": `aGl531TgLHEAxtjggQoP`,
	"textField": `HwBNFk6a380QSmWgcby5`,
	"warning": `TeDxIrWae0susvhiVtk0`,
	"error": `gCk9YEAH1hE_xuheJNrH`,
	"disabled": `HWeXUugxXYQg5Fj_W23U`,
	"inputLabel": `sH9WBf3H9gMaF_Yar2pZ`,
	"cardRightLabel": `UDKgqMXiA8yyB4UAS87F`,
	"trialText": `aG03BG9HgRIzpUELVSjB`
};
export default ___CSS_LOADER_EXPORT___;
